module.exports = __webpack_public_path__ + "img/24.e9b4c98c.png";